export default __webpack_public_path__ + "static/media/undraw_prioritise_tgdh.bcd9cd7d.png";